
import React, { useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from './theme/themes'; // Import themes
import { getThemeFromCookie, applyTheme, saveThemeToCookie } from './utils/themeUtils';
import { Container, Box } from '@mui/material';
import Header from './components/Header/Header';
import EducationSection from './components/Education/Education';
import Footer from './components/Footer/Footer';
import AppRouter from './AppRouter';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"


const App = () => {
  // Retrieve theme mode from cookie and set initial state
  const initialThemeMode = getThemeFromCookie() || 'light';
  applyTheme(initialThemeMode);
  const [themeMode, setThemeMode] = useState(initialThemeMode);

  // Toggle theme function
  const toggleTheme = () => {
    const newTheme = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newTheme);
    applyTheme(newTheme); // Update theme in global settings or cookies
    saveThemeToCookie(newTheme)
  };

  // Determine the appropriate theme
  const theme = themeMode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header with theme props */}
        <Header themeMode={themeMode} toggleTheme={toggleTheme} />
        
        {/* Main Content */}
        <Container maxWidth="sm" sx={{ padding: '1rem', flexGrow: 1 }}>
          {/* Tabs manage their own content */}
          <AppRouter />
          {/* Educational Content */}
          <EducationSection />
        </Container>
        <Footer />
        <Analytics />
        <SpeedInsights />
      </Box>
    </ThemeProvider>
  );
};

export default App;
